function closeAllMenus() {
    document.querySelectorAll(".nav-item").forEach((i) => {
        if (i.classList.contains("navbar_dropdown--open")) {
            i.classList.replace("navbar_dropdown--open", "navbar_dropdown")
            i.classList.add("navbar_dropdown")
        }

    })
}

// function closeAllActiveState() {
//     document.querySelectorAll(".nav-item").forEach((i) => {
//         console.log()
//         i.classList.remove("active")
//     })
// }

function handleTopMenuConfig() {
    document.querySelectorAll(".navbar_item").forEach((item) => {
        if (item.classList.contains("active")) {
            item.classList.remove("active")
        }
        item.addEventListener("click", function (event) {
            if (event.target.classList.contains("navbar_dropdown--open")) {
                event.target.classList.replace("navbar_dropdown--open", "navbar_dropdown")
                event.target.classList.add("navbar_dropdown")
                return;
            }
            closeAllMenus()
            // closeAllActiveState()
            // item.classList.add("active")

            if (event.currentTarget === item) {
                item.classList.replace("navbar_dropdown", "navbar_dropdown--open")
                item.classList.add("navbar_dropdown")
            } else {
                item.classList.replace("navbar_dropdown--open", "navbar_dropdown")
            }
        })
    })

}


export {
    handleTopMenuConfig,
    closeAllMenus
}

